import React from 'react'

import {Button} from '@vio/atlas/Button'
import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {useDispatchTeamEvent} from '@vio/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  noMoreReviews: boolean
  isLoading?: boolean
  onLoadMore: () => void
  sourceComponent: string
}
export const LoadMoreReviews: React.FC<Props> = ({
  noMoreReviews,
  isLoading = false,
  onLoadMore,
  sourceComponent
}) => {
  const dispatchTeamEvent = useDispatchTeamEvent()

  const handleLoadMore = () => {
    dispatchTeamEvent(
      trackEvent({
        category: Category.User,
        entity: Entity.ReviewDetailsLoadMoreButton,
        action: Action.Clicked,
        payload: {
          component: sourceComponent
        }
      })
    )
    onLoadMore()
  }
  if (noMoreReviews)
    return (
      <>
        <Divider />
        <Box
          textAlign="center"
          paddingBottom="s700"
          color="content.neutral.secondary"
        >
          <Text variant="bodyS">
            <FormattedMessageWrapper
              id="noMoreReviews"
              defaultMessage="No more reviews to show"
            />
          </Text>
        </Box>
      </>
    )

  return (
    <>
      <Divider />
      <Button
        loading={isLoading}
        variant="tertiary"
        iconStart={<Icon name="ArrowDown" />}
        onClick={handleLoadMore}
      >
        <FormattedMessageWrapper id="loadMore" defaultMessage="Load more" />
      </Button>
      <Box paddingBottom="s700" />
    </>
  )
}
